export const VALIDATION_ERROR_REQUIRED = 'REQUIRED';
export const VALIDATION_ERROR_UNIQUE = 'UNIQUE';
export const VALIDATION_ERROR_MAX_LENGTH = 'MAX_LENGTH';
export const VALIDATION_ERROR_SUM_WEIGHT = 'SUM_WEIGHT';
export const VALIDATION_ERROR_WEIGHT_FACTOR = 'WEIGHT_FACTOR';
export const VALIDATION_ERROR_KO_VALUE = 'KO_VALUE';
